import type { Theme, SxProps } from '@mui/material/styles';
import MuiButton, { type ButtonProps as MuiButtonProps } from '@mui/material/Button';

type ButtonVariant = 'primary' | 'secondary' | 'tertiary';

interface ButtonProps extends Omit<MuiButtonProps, 'variant' | 'color' | 'disableElevation'> {
  variant?: ButtonVariant;
}

const MUI_VARIANT: Record<ButtonVariant, Pick<MuiButtonProps, 'variant' | 'color'>> = {
  primary: { variant: 'contained', color: 'primary' },
  secondary: { variant: 'outlined', color: 'primary' },
  tertiary: { variant: 'text', color: 'primary' },
};

const focusVisibleSx: SxProps<Theme> = {
  '&:focus-visible': {
    outline: 'none',
    boxShadow: 'inset 0 0 0 2px currentColor',
  },
};

export function Button({ variant = 'primary', sx, ...props }: ButtonProps) {
  return (
    <MuiButton
      disableElevation
      {...MUI_VARIANT[variant]}
      {...props}
      sx={[focusVisibleSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    />
  );
}
